import { inject, Injectable } from '@angular/core';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldConfigPresetProvider } from '@ngx-formly/core/lib/models';
import { DataSetupFacade } from '@portal/application/data-access';
import { map, take } from 'rxjs';
import { mapDataSetupSelectOptionToFormly } from '../util';
import { FormlySelectOption } from '@ngx-formly/core/select';

@Injectable()
export class PropertyCompletionStatusPresetProvider implements FormlyFieldConfigPresetProvider {
  private readonly dataSetupFacade = inject(DataSetupFacade);

  getConfiguration(): FormlyFieldConfig {
    const options$ = this.dataSetupFacade.dataSetup$?.pipe(
      map(dataSetup => mapDataSetupSelectOptionToFormly(dataSetup?.collateralPropertyCompletionStatus)),
      take(1),
    );

    let options: FormlySelectOption[] = [];
    options$.subscribe(mappedOptions => {
      options = mappedOptions;
    });

    return {
      type: options.length > 2 ? 'mat-select' : 'button',
      props: {
        label: 'Property Completion Status',
        options: options,
      },
    };
  }
}

export function registerPropertyCompletionStatusPreset(): ConfigOption {
  return { presets: [{ name: 'propertyCompletionStatus', config: new PropertyCompletionStatusPresetProvider() }] };
}
